module.exports = __webpack_public_path__ + "img/signal_wifi_2_bar-green.f0406cbc.svg";